import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import {
  ActionInterface,
  ActionReturned,
  OptionActionEnum,
  advertiserActions,
  updateAdvertiserActions,
} from "src/app/shared/data/actions-data";
import {
  NgbdSortableHeader,
  SortEvent,
} from "src/app/shared/directive/sortable.directive";
import { AdvertiserDetailsInterface } from "src/app/shared/models/advertiser/profile.interface";
import { ResultFilterAdvertiser } from "src/app/shared/models/advertiser/result-filter-advertiser.interface";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { IColumn } from "src/app/shared/models/table/column.interface";
import { BadgeService } from "src/app/shared/services/badge.service";
import {
  approveAdvertiserByEmail,
  invokeAdvertiserFilter,
  invokeApproveAdvertiser,
  resultSuccess,
} from "src/app/store/advertiser/advertiser.actions";
import { initialState } from "src/app/store/advertiser/advertiser.reducers";
import {
  advertiserProfileDetailsSelector,
  approveAdvertiserSelector,
  loadingFilterSelector,
  resultFilterAdvertiserSelector,
  resultSuccessSelector,
} from "src/app/store/advertiser/advertiser.selectors";
import { AppStateInterface } from "src/app/store/appState.interface";
import { DetailsModalComponent } from "src/app/shared/components/details-modal/details-modal.component";
import { ToastrService } from "ngx-toastr";
import {
  advertiserFilter,
  FilterInterface,
} from "src/app/shared/data/filter-data";
import {
  AdvertiserStatusEnum,
  AdvertiserStatusEnumMapping,
} from "src/app/shared/enum/advertiser-status";
import { UpdateComponent } from "src/app/shared/components/drop-zone-options/modal/update/update.component";
import { TypeCards } from "src/app/shared/enum/typeCards";
import { saveUpdateFields } from "src/app/store/settings/settings.actions";
import { FilterListAdvertiser } from "src/app/shared/models/advertiser/filter-list-advertiser.interface";
import { invokeApiDistroyed } from "src/app/store/apiState.interface";
import { ResultCreateClient } from "src/app/shared/models/iberis/client/resultCreateClient";
import { resultCreateUpdateClientSelector } from "src/app/store/clientIberis/clientIberis.selectors";
import { DeleteAdvertiserComponent } from "./delete-advertiser/delete-advertiser.component";
import { UpdateAdvertiserStatusComponent } from "./update-advertiser-status/update-advertiser-status.component";
import { invokeSideBarNews } from "src/app/store/admin/admin.actions";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { Authorities } from "src/app/shared/enum/authorities";
import { JwtService } from "src/app/shared/services/jwt.service";
import { catchForbiddenErrorSelector } from "src/app/store/user/user.selectors";
import { catchForbiddenError } from "src/app/store/user/user.actions";
import { SendVerificationEmailComponent } from "./send-verification-email/send-verification-email.component";
import { UpdatePasswordComponent } from "src/app/shared/components/drop-zone-options/modal/update-password/update-password.component";
import { FilterParams } from "src/app/shared/models/filterParams";
import { FiltersService } from "src/app/shared/services/filters.service";
import { Constants } from "src/app/shared/data/constants";
import { resultCreateUpdateClient } from "src/app/store/clientIberis/clientIberis.actions";

@Component({
  selector: "app-advertisers",
  templateUrl: "./advertisers.component.html",
  styleUrls: ["./advertisers.component.scss"],
})
export class AdvertisersComponent extends BaseComponent implements OnInit {
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  approveInProgress: boolean | null;
  advertiserToApprove: string;
  statusToChange: boolean;
  emailAdvertiser: string;
  pageSize: number = Constants.defaultTableSize;
  pageNumber: number = 1;
  columns: IColumn[] = [
    {
      key: "companyName",
      label: "admin.advertisers.companyName",
      sorter: true,
      width: 25,
    },
    {
      key: "name",
      label: "admin.advertisers.fullName",
      sorter: true,
      width: 20,
    },
    {
      key: "phone",
      label: "admin.advertisers.phone",
      sorter: true,
      width: 10,
    },
    {
      key: "email",
      label: "admin.settings.access.collaborator.email",
      sorter: true,
      width: 30,
    },
    {
      key: "creationDate",
      label: "admin.advertisers.creationDate",
      sorter: true,
      width: 15,
    },
  ];
  advertiserFilter: FilterListAdvertiser = {
    ...initialState.filter,
    pager: {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
    },
  };
  resultFilterAdvertiser$: Observable<ResultFilterAdvertiser | null>;
  resultFilterAdvertiser: ResultFilterAdvertiser;

  resultApproveAdvertiser$: Observable<SuccessDto | null>;
  resultSuccessAdvertiser$: Observable<SuccessDto | null>;

  advertiserInfo$: Observable<AdvertiserDetailsInterface | null>;
  advertiserInfo: AdvertiserDetailsInterface | null;
  active = 1;
  submitted: boolean;
  validate: boolean;
  formFilter: FormGroup;
  form: FormGroup;
  options: ActionInterface[] = advertiserActions;
  optionSelected: string | null;
  loading$: Observable<boolean | null>;
  filterAdvertiser: FilterInterface = advertiserFilter;
  fields: ActionInterface[] = updateAdvertiserActions;
  clientCreatedInIberis$: Observable<ResultCreateClient | null>;
  selectedAdvertiser: AdvertiserDetailsInterface | null = null;

  advertiserActions = advertiserActions;
  filteredAdvertiserActions = advertiserActions;
  catchForbiddenError$: Observable<boolean | null>;
  forbidden: boolean | null = false;

  filters: FilterParams | null = null;

  count: number = 0;
  constructor(
    private store: Store<AppStateInterface>,
    private fb: FormBuilder,
    public badgeService: BadgeService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private toastr: ToastrService,
    private saveHistory: SaveUserHistoryService,
    private jwtService: JwtService,
    private filtersService: FiltersService
  ) {
    super(store);
    this.resultFilterAdvertiser$ = this.store
      .pipe(select(resultFilterAdvertiserSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultApproveAdvertiser$ = this.store
      .pipe(select(approveAdvertiserSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultSuccessAdvertiser$ = this.store
      .pipe(select(resultSuccessSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.advertiserInfo$ = this.store
      .pipe(select(advertiserProfileDetailsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.loading$ = this.store
      .pipe(select(loadingFilterSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.clientCreatedInIberis$ = this.store
      .pipe(select(resultCreateUpdateClientSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.formFilter = this.fb.group({
      email: [""],
    });
    this.form = this.fb.group({
      oldEmail: ["", Validators.required],
      newEmail: ["", Validators.required],
    });

    const authorities = this.jwtService.getPermissions(jwtService.getToken());
    if (authorities) {
      this.filteredAdvertiserActions.forEach((action) => {
        if (action.type === OptionActionEnum.ADMIN_ADVERTISER_UPDATE_STATUS) {
          action.disabled = !authorities.includes(
            Authorities.AD_UPDATE.toString()
          );
        }
      });

      this.forbidden = !authorities.includes(Authorities.AD_GETALL.toString());
    }

    this.extractFilters();
  }

  extractFilters() {
    this.filters = this.filtersService.decodeUri();
    if (this.filters) {
      this.advertiserFilter.status =
        this.findOption(this.filters.statuses) ?? [];
    }
    this.pageNumber = this.filtersService.extractValueFromUrl(
      this.filters,
      "page",
      this.pageNumber
    );
    this.pageSize = this.filtersService.extractValueFromUrl(
      this.filters,
      "size",
      this.pageSize
    );

    this.filtersService.patchFormValue(
      this.filters,
      ["email"],
      this.formFilter
    );

    this.advertiserFilter = {
      ...this.advertiserFilter,
      email: this.formFilter.get("email")?.value,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
  }

  ngOnInit(): void {
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
    this.filterAdvertiser.name.map(
      (e) =>
        (e.data = Object.keys(AdvertiserStatusEnum)
          .filter((value) => isNaN(Number(value)) === true)
          .map(
            (key: string | any) =>
              AdvertiserStatusEnumMapping[
                key as keyof typeof AdvertiserStatusEnum
              ]
          ))
    );
    this.loading$.subscribe((data) => {});
    this.loadData();
    this.resultFilterAdvertiser$.subscribe(
      (result: ResultFilterAdvertiser | null) => {
        if (result) {
          this.resultFilterAdvertiser = result;
          this.count = result.count;
          this.saveHistory.saveUserHistory(
            UserHistoryActionsEnum.GET,
            UserHistoryServicesEnum.LIST_ADVERTISERS
          );
        }
      }
    );
    this.store.dispatch(approveAdvertiserByEmail({ successMessage: null }));

    this.resultApproveAdvertiser$.subscribe((result: SuccessDto | null) => {
      if (result != null) {
        this.toastr.success(
          this.translate.instant("response.success." + result.message),
          this.translate.instant("response.successTitle")
        );

        this.loadData();
        this.modalService.dismissAll();
        this.store.dispatch(approveAdvertiserByEmail({ successMessage: null }));
        this.selectedAdvertiser = null;
      }
    });

    this.resultSuccessAdvertiser$.subscribe((result: SuccessDto | null) => {
      if (result != null) {
        this.toastr.success(
          this.translate.instant("response.success." + result.message),
          this.translate.instant("response.successTitle")
        );
        this.loadData();
        this.modalService.dismissAll();
        this.store.dispatch(resultSuccess({ successMessage: null }));
      }
    });

    this.clientCreatedInIberis$.subscribe(
      (result: ResultCreateClient | null) => {
        if (result) {
          if(result?.status.code === 200){
            if (this.selectedAdvertiser) {
              this.store.dispatch(
                invokeApproveAdvertiser({
                  dto: {
                    email: this.selectedAdvertiser.email,
                    status: AdvertiserStatusEnum.ENABLED,
                    iberis: result.data.client.hashed_id,
                  },
                })
              );
              this.store.dispatch(invokeSideBarNews());
            }
          }else{
            this.toastr.error(
              this.translate.instant("response.error.BILLING_SERVICE_FAILED"),
              this.translate.instant("response.errorTitle")
            );
            this.modalService.dismissAll()
          }
          this.store.dispatch(resultCreateUpdateClient({createClient : null}))
        }
      }
    );
    this.advertiserInfo$.subscribe(
      (result: AdvertiserDetailsInterface | null) => {
        if (result) {
          this.advertiserInfo = result;
        }
      }
    );

    this.formFilter.valueChanges.subscribe((value) => {
      this.pageNumber = 1
      this.pageSize = Constants.defaultTableSize;
      this.advertiserFilter = {
        ...this.advertiserFilter,
        email: value.email,
        pager: {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        },
      };
      this.loadData();
    });
  }

  loadData() {
    this.store.dispatch(invokeApiDistroyed());
    this.store.dispatch(
      invokeAdvertiserFilter({
        filter: {
          ...this.advertiserFilter,
        },
      })
    );
  }

  removeFilter() {
    this.formFilter.reset({
      companyName: "",
      email: "",
      lastName: "",
      firstName: "",
      companyAddress: "",
      companyActivity: "",
    });
    this.store.dispatch(
      invokeAdvertiserFilter({
        filter: {
          ...initialState.filter,
          pager: {
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,
          },
        },
      })
    );
  }

  onSort({ column, direction }: SortEvent) {
    this.store.dispatch(invokeApiDistroyed());
    this.headers.forEach((header) => {
      if (column != header.sortable) {
        header.direction = "";
      }
    });
    var col: string | null = column;
    var sort = null;
    switch (direction) {
      case "asc":
        sort = true;
        break;
      case "desc":
        sort = false;
        break;
      default:
        sort = true;
        col = null;
    }

    this.advertiserFilter = {
      ...this.advertiserFilter,
      sortName: col,
      isAscending: sort,
    };
    this.loadData();
  }

  itemsPerPageChange(pageSize: number) {
    this.pageSize = pageSize;
    this.pageNumber = 1;
    this.advertiserFilter = {
      ...this.advertiserFilter,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
    this.loadData();
  }

  changePage(event: number) {
    this.pageNumber = event;
    this.advertiserFilter = {
      ...this.advertiserFilter,
      pager: {
        ...this.advertiserFilter.pager,
        pageNumber: this.pageNumber,
      },
    };
    this.loadData();
  }

  findOption(options: AdvertiserStatusEnum[] | null) {
    let status: any[] = [];
    options?.map((option) => {
      status.push(
        Object.keys(AdvertiserStatusEnum).find(
          (key) =>
            AdvertiserStatusEnumMapping[key as AdvertiserStatusEnum] === option
        )
      );
    });
    return status;
  }
  saveOption(options: AdvertiserStatusEnum[] | null) {
    let status = this.findOption(options);
    this.pageNumber = 1;
    this.advertiserFilter = {
      ...this.advertiserFilter,
      status: status,
      pager: {
        ...this.advertiserFilter.pager,
        pageNumber: this.pageNumber,
      },
    };
    this.loadData();
  }

  saveAction(action: ActionReturned, advertiser: AdvertiserDetailsInterface) {
    switch (action.option.type) {
      case OptionActionEnum.ADMIN_ADVERTISER_UPDATE_STATUS: {
        const modal = this.modalService.open(UpdateAdvertiserStatusComponent, {
          centered: true,
        });
        this.selectedAdvertiser = advertiser;
        modal.componentInstance.advertiser = advertiser;
        modal.componentInstance.title = action.option.name;
        break;
      }
      case OptionActionEnum.ADMIN_ADVERTISER_DELETE: {
        const modal = this.modalService.open(DeleteAdvertiserComponent, {
          centered: true,
        });
        modal.componentInstance.email = advertiser.email;
        break;
      }
      case OptionActionEnum.ADMIN_ADVERTISER_DETAILS: {
        const modal = this.modalService.open(DetailsModalComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.details = advertiser;
        modal.componentInstance.title = action.option.name;
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.ADVERTISER_DETAILS
        );
        break;
      }
      case OptionActionEnum.ADMIN_ADVERTISER_SEND_VERIFICATION_EMAIL: {
        const modal = this.modalService.open(SendVerificationEmailComponent, {
          centered: true,
        });
        modal.componentInstance.email = advertiser.email;
        break;
      }
      case OptionActionEnum.ADMIN_ADVERTISER_UPDATE: {
        this.store.dispatch(saveUpdateFields({ options: this.fields }));
        const modalRef = this.modalService.open(UpdateComponent, {
          centered: true,
          size: "xl",
        });
        modalRef.componentInstance.isCol4 = true;
        modalRef.componentInstance.type = TypeCards.ADMIN_ADVERTISER_UPDATE;
        modalRef.componentInstance.title =
          "actions.advertiser.updateAdvertiser";
        modalRef.componentInstance.advertiser = advertiser;
        modalRef.componentInstance.email = advertiser.email;
        modalRef.closed.subscribe(() => this.loadData());
        break;
      }
      case OptionActionEnum.ADMIN_ADVERTISER_UPDATE_PASSWORD: {
        const modal = this.modalService.open(UpdatePasswordComponent, {
          centered: true,
        });
        modal.componentInstance.companyName = advertiser.companyName;
        modal.componentInstance.email = advertiser.email;
        modal.componentInstance.closeTheModal.subscribe((value: boolean) => {
          if (value) {
            modal.close();
          }
        });
        break;
      }
    }
  }

  onOpenMenu(status: AdvertiserStatusEnum) {
    this.filteredAdvertiserActions = this.advertiserActions.filter((action) => {
      if (
        action.type ===
        OptionActionEnum.ADMIN_ADVERTISER_SEND_VERIFICATION_EMAIL
      ) {
        if (status !== AdvertiserStatusEnum.EMAIL_VERIFICATION) {
          return false;
        }
      }
      return true;
    });
  }

  getOptions(status: AdvertiserStatusEnum): ActionInterface[] {
    if (status == AdvertiserStatusEnum.EMAIL_VERIFICATION)
      return this.filteredAdvertiserActions.filter(
        (value) => value.type != OptionActionEnum.ADMIN_ADVERTISER_ACTIVATE
      );
    return this.filteredAdvertiserActions;
  }

  onClickshowEditModal(editAdvertiser: any, email: string) {
    this.form.patchValue({ oldEmail: email });
    const modalRef = this.modalService.open(editAdvertiser);
    this.emailAdvertiser = email;
  }
}
